// Modules
import { useReducer } from "react";

export const SET_SINGLE_THERAPIST = "SET_SINGLE_THERAPIST";
export const SET_MULTIPLE_THERAPISTS = "SET_MULTIPLE_THERAPISTS";
export const SET_MULTIPLE_THERAPISTS_BATCH = "SET_MULTIPLE_THERAPISTS_BATCH";

type TherapistSelectionAction =
    | {
          type: typeof SET_SINGLE_THERAPIST | typeof SET_MULTIPLE_THERAPISTS;
          id: string;
          value: boolean;
      }
    | {
          type: typeof SET_MULTIPLE_THERAPISTS_BATCH;
          therapists: Record<string, boolean>;
      };

const useTherapistSelection = () => {
    const [calendars, dispatch] = useReducer((state: Record<string, boolean>, action: TherapistSelectionAction) => {
        switch (action.type) {
            case SET_SINGLE_THERAPIST:
                return { [action.id]: action.value };
            case SET_MULTIPLE_THERAPISTS:
                return { ...state, [action.id]: action.value };
            case SET_MULTIPLE_THERAPISTS_BATCH:
                return action.therapists;
            default:
                return state;
        }
    }, {});

    const handleTherapistSelectionHook = (id: string, value: boolean, isSingleTherapist = false) => {
        const actionType = isSingleTherapist ? SET_SINGLE_THERAPIST : SET_MULTIPLE_THERAPISTS;
        dispatch({ type: actionType, id, value });
    };

    const handleBatchTherapistSelection = (therapists: Record<string, boolean>) => {
        dispatch({ type: SET_MULTIPLE_THERAPISTS_BATCH, therapists });
    };

    return { calendars, handleTherapistSelectionHook, handleBatchTherapistSelection };
};

export default useTherapistSelection;
